
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/settings/brand/users",
      function () {
        return require("private-next-pages/settings/brand/users.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/settings/brand/users"])
      });
    }
  